"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Runner = void 0;
const interpreter_1 = require("./interpreter");
const parser_1 = require("./parser");
const resolver_1 = require("./resolver");
const scanner_1 = require("./scanner");
class Runner {
    constructor(stdOut, stdErr) {
        this.stdErr = stdErr;
        this.interpreter = new interpreter_1.Interpreter(stdOut, stdErr);
    }
    run(source) {
        const scanner = new scanner_1.Scanner(source, this.stdErr);
        const tokens = scanner.scanTokens();
        const parser = new parser_1.Parser(tokens, this.stdErr);
        let { statements, hadError } = parser.parse();
        if (hadError) {
            return this.interpreter.stringify(null);
        }
        const resolver = new resolver_1.Resolver(this.interpreter, this.stdErr);
        hadError = resolver.resolveStmts(statements);
        if (hadError) {
            return this.interpreter.stringify(null);
        }
        return this.interpreter.stringify(this.interpreter.interpret(statements));
    }
}
exports.Runner = Runner;
